
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const InterfacePage = lazy(() => import('../pages/interface/page'));
const OperationsPage = lazy(() => import('../pages/operations/page'));
const ProofPage = lazy(() => import('../pages/proof/page'));
const PaymentPage = lazy(() => import('../pages/payment/page'));
const PaymentSuccessPage = lazy(() => import('../pages/payment/success'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <InterfacePage />,
  },
  {
    path: '/operations',
    element: <OperationsPage />,
  },
  {
    path: '/proof',
    element: <ProofPage />,
  },
  {
    path: '/payment',
    element: <PaymentPage />,
  },
  {
    path: '/payment-success',
    element: <PaymentSuccessPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
